import { useRouter } from 'next/router';

import { useRentalManagerUserPropertyMultiplexWebApiHandler_overview } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import { useMultiplexBuildingSessionId } from './useMultiplexBuildingSessionId';

// Backend will add listingAlias to OverviewParams in ts-rental-manager-api-beta-client; remove this type once regenerated.
type MultiplexOverviewGetParams = {
  listingAlias?: string;
  multiplexBuildingSessionId: string;
};

export const useMultiplexOverview = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string | undefined;
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const getParams: MultiplexOverviewGetParams = {
    multiplexBuildingSessionId: multiplexBuildingSessionId ?? '',
    ...(listingAlias ? { listingAlias } : {}),
  };

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_overview(
    getParams as { multiplexBuildingSessionId: string },
    {
      enabled: enabled && Boolean(multiplexBuildingSessionId && listingAlias),
      meta: {
        tags:
          multiplexBuildingSessionId && listingAlias
            ? ['multiplexBuildingSessionOverview', multiplexBuildingSessionId, listingAlias]
            : multiplexBuildingSessionId
              ? ['multiplexBuildingSessionOverview', multiplexBuildingSessionId]
              : ['multiplexBuildingSessionOverview'],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_overview',
          details: 'useMultiplexOverview',
        },
      },
    },
  );

  return { data, isFetching, error };
};
